import { useIntl } from "components/_hooks/useIntl";
import { useEffect } from "react";
import { defineMessages } from "react-intl";

const messages = defineMessages({
  myAccount: {
    id: "document.title",
    defaultMessage: "MyAccount"
  }
});

export const useLocalisedDocumentTitle = () => {
  const intl = useIntl();
  useEffect(() => {
    const title = intl.formatMessage(messages.myAccount);
    document.title = title;
  }, []);
};
